/* ══ ANNOUNCEMENT BAR HEIGHT → HEADER OFFSET ══ */
(function() {
  var bar = document.getElementById('announcementBar');
  if (!bar) return;
  function setBarHeight() {
    document.documentElement.style.setProperty('--bar-h', bar.offsetHeight + 'px');
  }
  setBarHeight();
  window.addEventListener('load', setBarHeight);
  window.addEventListener('resize', setBarHeight);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(setBarHeight);
  }
})();

/* ══ ANNOUNCEMENT BAR — ROTATING LINES (isolated; scoped to #announcementBar only) ══ */
(function() {
  var lfAnnounceBar = document.getElementById('announcementBar');
  if (!lfAnnounceBar) return;
  // Query ONLY within the bar — never a global selector, so it can never reach
  // the stitch SVG <line> elements or anything else on the page.
  var lfAnnounceLines = lfAnnounceBar.querySelectorAll('.announcement-bar__line');
  if (lfAnnounceLines.length < 2) return;
  var lfAnnounceIdx = 0;
  var lfAnnounceTimer = setInterval(function() {
    lfAnnounceLines[lfAnnounceIdx].classList.remove('is-active');
    lfAnnounceIdx = (lfAnnounceIdx + 1) % lfAnnounceLines.length;
    lfAnnounceLines[lfAnnounceIdx].classList.add('is-active');
  }, 4000);
})();

/* ══ SCROLL-AWARE HEADER + STICKY OFFSET SYNC ══
   Broadcasts the header's live bottom edge as --header-bottom-offset so
   sticky elements (e.g. the PDP columns) can track it. This has to live in
   the same handler as the .scrolled toggle below — reading the header's
   rect from a separate, independently-registered scroll listener races
   against this class toggle and captures a one-tick-stale value. It also
   keeps sampling for the duration of the header's CSS "top" transition
   (base.css: .site-header { transition: ... top 0.4s }) so the offset
   doesn't freeze mid-animation. */
(function() {
  var header = document.getElementById('siteHeader');
  var bar = document.getElementById('announcementBar');
  if (!header) return;
  /* On templates with a full-bleed hero directly under the header (currently
     just the homepage's .fiv-hero), gate the "scrolled" reveal on having
     cleared the hero itself rather than an arbitrary pixel threshold — so
     it tracks correctly regardless of viewport height. Templates without a
     hero fall back to the announcement-bar-based threshold below. */
  var hero = document.querySelector('.fiv-hero');

  function updateHeaderOffset() {
    var bottomEdge = Math.max(header.getBoundingClientRect().bottom, 0);
    document.documentElement.style.setProperty('--header-bottom-offset', bottomEdge + 'px');
  }

  var settleRaf = null;
  var settleUntil = 0;
  function settleOffset() {
    updateHeaderOffset();
    if (performance.now() < settleUntil) {
      settleRaf = requestAnimationFrame(settleOffset);
    } else {
      settleRaf = null;
    }
  }
  function trackDuringTransition() {
    settleUntil = performance.now() + 500;
    if (!settleRaf) settleRaf = requestAnimationFrame(settleOffset);
  }

  function isPastThreshold() {
    if (hero) return hero.getBoundingClientRect().bottom <= 0;
    var threshold = bar ? bar.offsetHeight + 10 : 40;
    return window.scrollY > threshold;
  }

  function onScroll() {
    var wasScrolled = header.classList.contains('scrolled');
    var isScrolled = isPastThreshold();
    header.classList.toggle('scrolled', isScrolled);
    updateHeaderOffset();
    if (wasScrolled !== isScrolled) trackDuringTransition();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  /* Re-run onScroll (not just updateHeaderOffset) on resize: a hero's
     height can change with the viewport, which can cross the threshold
     without any actual scrolling. */
  window.addEventListener('resize', onScroll, { passive: true });
  window.addEventListener('load', updateHeaderOffset);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(updateHeaderOffset);
  }
  if ('ResizeObserver' in window) {
    new ResizeObserver(updateHeaderOffset).observe(header);
  }
  header.addEventListener('transitionend', function(e) {
    if (e.propertyName === 'top') updateHeaderOffset();
  });

  onScroll();
})();

/* ══ REVEAL ANIMATIONS — bfcache-safe + safety net ══ */
(function() {
  var els = document.querySelectorAll('.js-reveal');

  function showAll() {
    els.forEach(function(el) { el.classList.add('is-visible'); });
  }

  /* On back/forward navigation, skip the animation entirely */
  window.addEventListener('pageshow', function(e) {
    if (e.persisted) showAll();
  });

  if (!('IntersectionObserver' in window)) { showAll(); return; }

  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry, i) {
      if (entry.isIntersecting) {
        setTimeout(function() { entry.target.classList.add('is-visible'); }, i * 25);
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });
  els.forEach(function(el) { io.observe(el); });

  /* Safety net: reveal anything still hidden after 1.5s */
  setTimeout(showAll, 1500);
})();

/* ══ SMOOTH SCROLL ANCHORS ══ */
document.querySelectorAll('a[href^="#"]').forEach(function(a) {
  a.addEventListener('click', function(e) {
    var t = document.querySelector(a.getAttribute('href'));
    if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth' }); }
  });
});

/* ══ MOBILE NAV ══ */
function openMobileNav() {
  document.getElementById('mobileNav').classList.add('is-open');
  document.getElementById('navOverlay').classList.add('is-open');
  document.body.classList.add('lf-nav-open');
  document.body.style.overflow = 'hidden';
}
function closeMobileNav() {
  document.getElementById('mobileNav').classList.remove('is-open');
  document.getElementById('navOverlay').classList.remove('is-open');
  document.body.classList.remove('lf-nav-open');
  document.body.style.overflow = '';
}
function lfToggleNavGroup(btn) {
  var group = btn.closest('.mobile-nav__group');
  if (!group) return;
  var sub = group.querySelector('.mobile-nav__subgroup');
  var isOpen = btn.getAttribute('aria-expanded') === 'true';
  btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
  if (sub) sub.classList.toggle('is-open', !isOpen);
}

/* ══ SEARCH BAR ══ */
function openSearch() {
  var bar = document.getElementById('siteSearchBar');
  var btn = document.getElementById('searchOpen');
  if (!bar) return;
  bar.classList.add('is-open');
  if (btn) btn.setAttribute('aria-expanded', 'true');
  var input = document.getElementById('siteSearchInput');
  if (input) setTimeout(function() { input.focus(); }, 150);
  document.addEventListener('click', lfSearchOutsideClick);
  document.addEventListener('keydown', lfSearchEscape);
}
function closeSearch() {
  var bar = document.getElementById('siteSearchBar');
  var btn = document.getElementById('searchOpen');
  if (!bar) return;
  bar.classList.remove('is-open');
  if (btn) btn.setAttribute('aria-expanded', 'false');
  document.removeEventListener('click', lfSearchOutsideClick);
  document.removeEventListener('keydown', lfSearchEscape);
}
function lfSearchOutsideClick(e) {
  var bar = document.getElementById('siteSearchBar');
  var btn = document.getElementById('searchOpen');
  if (!bar || bar.contains(e.target) || (btn && btn.contains(e.target))) return;
  closeSearch();
}
function lfSearchEscape(e) {
  if (e.key === 'Escape') closeSearch();
}

/* ══ FORMAT MONEY (Indian Rupees, no decimals) ══ */
function formatMoney(paise) {
  var rupees = Math.round(paise / 100);
  return '₹' + rupees.toLocaleString('en-IN');
}

/* ══ CART DRAWER ══ */
function openCartDrawer() {
  renderCartDrawer();
  document.getElementById('cartDrawer').classList.add('is-open');
  document.getElementById('navOverlay').classList.add('is-open');
  document.body.style.overflow = 'hidden';
  document.dispatchEvent(new CustomEvent('cart:open'));
}
function closeCartDrawer() {
  document.getElementById('cartDrawer').classList.remove('is-open');
  document.getElementById('navOverlay').classList.remove('is-open');
  document.body.style.overflow = '';
}

function renderCartDrawer() {
  var container = document.getElementById('cartDrawerItems');
  if (container) {
    container.style.transition = 'opacity 0.15s ease';
    container.style.opacity = '0.35';
  }

  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var footer = document.getElementById('cartDrawerFooter');
      var countEl = document.getElementById('cartDrawerCount');
      var subtotalEl = document.getElementById('cartDrawerSubtotal');

      var badge = document.getElementById('cartBadge');
      if (badge) {
        var count = cart.item_count || 0;
        badge.textContent = count;
        badge.style.display = count > 0 ? 'flex' : 'none';
      }

      if (cart.item_count === 0) {
        container.innerHTML =
          '<div class="cart-drawer__empty">' +
            '<div class="cart-drawer__empty-title">Your bag is empty</div>' +
            '<p class="cart-drawer__empty-text">You haven\'t added anything yet.</p>' +
            '<a href="/collections/all" class="btn-dark" style="max-width:220px;margin:0 auto;">Start Shopping</a>' +
          '</div>';
        footer.style.display = 'none';
        countEl.textContent = '0 items';
        if (container) requestAnimationFrame(function() { container.style.opacity = '1'; });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        return;
      }

      countEl.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');

      var html = '';
      cart.items.forEach(function(item) {
        var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        var imgSrc = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/, '_200x$1$2') : '';

        html +=
          '<div class="cart-drawer-item">' +
            '<div class="cart-drawer-item__img">' +
              (imgSrc ? '<img src="' + imgSrc + '" alt="' + item.product_title + '" loading="lazy">' : '') +
            '</div>' +
            '<div class="cart-drawer-item__info">' +
              '<div class="cart-drawer-item__name">' + item.product_title + '</div>' +
              (variantTitle ? '<div class="cart-drawer-item__variant">' + variantTitle + '</div>' : '') +
              '<div class="cart-drawer-item__bottom">' +
                '<div class="cart-drawer-item__qty">' +
                  '<button class="cart-drawer-item__qty-btn" onclick="cartDrawerQty(\'' + item.key + '\',' + (item.quantity - 1) + ')">−</button>' +
                  '<span class="cart-drawer-item__qty-val">' + item.quantity + '</span>' +
                  '<button class="cart-drawer-item__qty-btn" onclick="cartDrawerQty(\'' + item.key + '\',' + (item.quantity + 1) + ')">+</button>' +
                '</div>' +
                '<span class="cart-drawer-item__price">' + formatMoney(item.final_line_price) + '</span>' +
              '</div>' +
              '<button class="cart-drawer-item__remove" onclick="cartDrawerQty(\'' + item.key + '\',0)">Remove</button>' +
            '</div>' +
          '</div>';
      });
      container.innerHTML = html;
      requestAnimationFrame(function() { container.style.opacity = '1'; });

      subtotalEl.textContent = formatMoney(cart.total_price);
      var checkoutBtn = document.getElementById('cartDrawerCheckout');
      if (checkoutBtn) checkoutBtn.textContent = 'Pay Now — ' + formatMoney(cart.total_price);
      footer.style.display = 'block';

      /* Fire event so upsell snippet updates */
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    });
}

function cartDrawerQty(key, qty) {
  /* ── FULL OPTIMISTIC UI: update everything instantly ── */
  var rowBtn = document.querySelector('[onclick*="' + key + '"]');
  var row = rowBtn ? rowBtn.closest('.cart-drawer-item') : null;

  /* Compute new totals optimistically */
  var items = document.querySelectorAll('.cart-drawer-item');
  var newItemCount = 0;
  var newTotal = 0;

  items.forEach(function(r) {
    var rowKey = r.querySelector('[onclick*="cartDrawerQty"]');
    var thisKey = rowKey ? rowKey.getAttribute('onclick').match(/'([^']+)'/)[1] : null;
    var qtyEl = r.querySelector('.cart-drawer-item__qty-val');
    var priceEl = r.querySelector('.cart-drawer-item__price');
    var currentQty = qtyEl ? parseInt(qtyEl.textContent) || 0 : 0;
    var currentPrice = priceEl ? parseInt((priceEl.textContent || '').replace(/[^0-9]/g, '')) || 0 : 0;
    var unitPrice = currentQty > 0 ? currentPrice / currentQty : 0;

    if (thisKey === key) {
      if (qty === 0) { /* skip row */ }
      else {
        newItemCount += qty;
        newTotal += unitPrice * qty;
        /* update row instantly */
        if (qtyEl) qtyEl.textContent = qty;
        if (priceEl) priceEl.textContent = '₹' + Math.round(unitPrice * qty).toLocaleString('en-IN');
        var minusBtn = r.querySelectorAll('.cart-drawer-item__qty-btn')[0];
        var plusBtn = r.querySelectorAll('.cart-drawer-item__qty-btn')[1];
        if (minusBtn) minusBtn.setAttribute('onclick', "cartDrawerQty('" + key + "'," + (qty - 1) + ")");
        if (plusBtn) plusBtn.setAttribute('onclick', "cartDrawerQty('" + key + "'," + (qty + 1) + ")");
      }
    } else {
      newItemCount += currentQty;
      newTotal += currentPrice;
    }
  });

  /* Update subtotal instantly */
  var subtotalEl = document.getElementById('cartDrawerSubtotal');
  if (subtotalEl) subtotalEl.textContent = '₹' + Math.round(newTotal).toLocaleString('en-IN');
  var checkoutBtn = document.getElementById('cartDrawerCheckout');
  if (checkoutBtn && newItemCount > 0) checkoutBtn.textContent = 'Pay Now — ₹' + Math.round(newTotal).toLocaleString('en-IN');

  /* Update count instantly */
  var countEl = document.getElementById('cartDrawerCount');
  if (countEl) countEl.textContent = newItemCount + (newItemCount === 1 ? ' item' : ' items');

  /* Update header badge */
  var badge = document.getElementById('cartBadge');
  if (badge) {
    badge.textContent = newItemCount;
    badge.style.display = newItemCount > 0 ? 'flex' : 'none';
  }

  /* Remove row visually */
  if (qty === 0 && row) {
    row.style.transition = 'opacity 0.2s, transform 0.2s, max-height 0.25s';
    row.style.maxHeight = row.offsetHeight + 'px';
    requestAnimationFrame(function() {
      row.style.opacity = '0';
      row.style.transform = 'translateX(16px)';
      row.style.maxHeight = '0';
      row.style.padding = '0';
      row.style.margin = '0';
      row.style.overflow = 'hidden';
    });
    setTimeout(function() { row.remove(); }, 250);
  }

  /* If cart empty, show empty state instantly */
  if (newItemCount === 0) {
    var container = document.getElementById('cartDrawerItems');
    var footer = document.getElementById('cartDrawerFooter');
    setTimeout(function() {
      if (container) container.innerHTML =
        '<div class="cart-drawer__empty">' +
          '<div class="cart-drawer__empty-title">Your bag is empty</div>' +
          '<p class="cart-drawer__empty-text">You haven\'t added anything yet.</p>' +
          '<a href="/collections/all" class="btn-dark" style="max-width:220px;margin:0 auto;">Start Shopping</a>' +
        '</div>';
      if (footer) footer.style.display = 'none';
    }, 260);
  }

  /* Fire OPTIMISTIC cart:updated event IMMEDIATELY so upsell updates instantly */
  document.dispatchEvent(new CustomEvent('cart:updated', { detail: {
    item_count: newItemCount,
    total_price: Math.round(newTotal) * 100,
    items: []
  }}));

  /* Background sync */
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(function(r) { return r.json(); })
  .then(function(cart) {
    /* Fire real cart:updated with full data */
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
  });
}

/* ══ QUICK ADD (product cards) ══
   Single-variant products add straight to cart; multi-variant products open
   a size-selector sheet first. Both paths end at the same AJAX add below,
   mirroring the fetch('/cart/add.js', {items:[...]}) + openCartDrawer()
   pattern already used by the PDP's doAddToCart() in lf-product-page.js. */
var lfQuickAddState = { variantId: null };

function lfQuickAdd(btn) {
  if (btn.disabled) return;
  if (btn.dataset.mode === 'direct') {
    lfAddToCartFromCard(btn.dataset.variantId, btn);
    return;
  }
  var data;
  try {
    data = JSON.parse(btn.getAttribute('data-drawer'));
  } catch (e) {
    return;
  }
  lfOpenQuickAdd(data);
}

function lfOpenQuickAdd(data) {
  lfQuickAddState.variantId = null;

  var nameEl = document.getElementById('quickAddName');
  var priceEl = document.getElementById('quickAddPrice');
  if (nameEl) nameEl.textContent = data.name || '';
  if (priceEl) priceEl.textContent = data.price || '';

  var sizesEl = document.getElementById('quickAddSizes');
  if (sizesEl) {
    var unavailable = data.unavailable || [];
    var html = '';
    (data.sizes || []).forEach(function(size) {
      var variant = (data.variants || []).filter(function(v) { return v.option1 === size; })[0];
      var isUnavailable = unavailable.indexOf(size) !== -1 || !variant || !variant.available;
      html += '<button type="button" class="quick-add-popup__size' + (isUnavailable ? ' is-unavailable' : '') + '"' +
        (variant ? ' data-variant-id="' + variant.id + '"' : '') +
        (isUnavailable ? ' disabled' : '') +
        ' onclick="lfSelectQuickAddSize(this)">' + size + '</button>';
    });
    sizesEl.innerHTML = html;
  }

  var errorEl = document.getElementById('quickAddError');
  if (errorEl) errorEl.hidden = true;
  var submitBtn = document.getElementById('quickAddSubmit');
  if (submitBtn) { submitBtn.textContent = 'Add to Cart'; submitBtn.disabled = false; }

  document.getElementById('quickAddOverlay').classList.add('is-open');
  document.getElementById('quickAddPopup').classList.add('is-open');
  document.body.style.overflow = 'hidden';
}

function closeQuickAdd() {
  document.getElementById('quickAddOverlay').classList.remove('is-open');
  document.getElementById('quickAddPopup').classList.remove('is-open');
  document.body.style.overflow = '';
}

function lfSelectQuickAddSize(el) {
  if (el.disabled) return;
  document.querySelectorAll('.quick-add-popup__size').forEach(function(b) { b.classList.remove('is-selected'); });
  el.classList.add('is-selected');
  lfQuickAddState.variantId = el.dataset.variantId;
  var errorEl = document.getElementById('quickAddError');
  if (errorEl) errorEl.hidden = true;
}

function lfConfirmQuickAdd() {
  var errorEl = document.getElementById('quickAddError');
  if (!lfQuickAddState.variantId) {
    if (errorEl) errorEl.hidden = false;
    return;
  }
  if (errorEl) errorEl.hidden = true;
  var submitBtn = document.getElementById('quickAddSubmit');
  lfAddToCartFromCard(lfQuickAddState.variantId, submitBtn, closeQuickAdd);
}

/* Shared AJAX add for card buttons — btn may be a card's quick-add button
   (has a <span> label) or the popup's plain-text submit button. */
function lfAddToCartFromCard(variantId, btn, onDone) {
  if (!variantId) return;
  var vid = parseInt(variantId, 10);
  var label = btn.querySelector('span');
  var originalText = label ? label.textContent : btn.textContent;

  var card = btn.closest('.product-card');
  var cardImg = card ? card.querySelector('.product-card__image img') : null;
  if (window.LF && window.LF.flyToCart && cardImg) {
    window.LF.flyToCart(cardImg, btn);
  }

  var c = document.getElementById('cartBadge');
  if (c) {
    c.textContent = (parseInt(c.textContent) || 0) + 1;
    c.style.display = 'flex';
  }

  btn.disabled = true;
  btn.classList.add('is-added');
  if (label) label.textContent = 'Added'; else btn.textContent = 'Added';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
  })
  .then(function(r) { return r.json(); })
  .then(function() {
    if (window.LF && typeof window.LF.openCartDrawer === 'function') window.LF.openCartDrawer();
    setTimeout(function() {
      btn.disabled = false;
      btn.classList.remove('is-added');
      if (label) label.textContent = originalText; else btn.textContent = originalText;
    }, 1000);
    if (onDone) onDone();
  })
  .catch(function() {
    if (c) {
      var newVal = (parseInt(c.textContent) || 0) - 1;
      c.textContent = newVal;
      if (newVal <= 0) c.style.display = 'none';
    }
    btn.disabled = false;
    btn.classList.remove('is-added');
    if (label) label.textContent = originalText; else btn.textContent = originalText;
  });
}

/* ── Close overlays ── */
document.getElementById('navOverlay').addEventListener('click', function() {
  closeMobileNav();
  closeCartDrawer();
});
document.getElementById('quickAddOverlay').addEventListener('click', closeQuickAdd);


window.LF.openCartDrawer = openCartDrawer;
window.LF.closeCartDrawer = closeCartDrawer;

/* ══ FLY TO CART — Web Animations API (reliable on iOS Safari) ══ */
window.LF.flyToCart = function(sourceEl, originEl) {
  if (!originEl) return;
  var cartIcon = document.getElementById('cartIcon');
  if (!cartIcon) return;

  /* Image src for visual */
  var imgSrc = '';
  if (sourceEl) {
    var srcImg = sourceEl.tagName === 'IMG' ? sourceEl : sourceEl.querySelector('img');
    if (srcImg && srcImg.src) imgSrc = srcImg.src;
  }

  var oRect = originEl.getBoundingClientRect();
  var tgtRect = cartIcon.getBoundingClientRect();
  var W = 130, H = 165;

  var startX = oRect.left + (oRect.width - W) / 2;
  var startY = Math.max(20, oRect.top - H - 8);
  var endX = (tgtRect.left + tgtRect.width / 2) - W / 2;
  var endY = (tgtRect.top + tgtRect.height / 2) - H / 2;
  var midX = (startX + endX) / 2;
  var midY = Math.min(startY, endY) - 80;

  var clone = document.createElement('div');
  clone.style.cssText =
    'position:fixed;left:0;top:0;width:' + W + 'px;height:' + H + 'px;' +
    'transform:translate(' + startX + 'px,' + startY + 'px);' +
    (imgSrc ? 'background:#0C0C0C url(' + imgSrc + ') center/cover no-repeat;' : 'background:#0C0C0C;') +
    'z-index:99999;pointer-events:none;' +
    'box-shadow:0 14px 36px rgba(10,10,10,0.45);' +
    'will-change:transform,opacity;border-radius:0;';
  document.body.appendChild(clone);

  if (clone.animate) {
    var anim = clone.animate([
      { transform: 'translate(' + startX + 'px,' + startY + 'px) scale(1) rotate(0deg)', opacity: 1 },
      { transform: 'translate(' + midX + 'px,' + midY + 'px) scale(0.7) rotate(8deg)', opacity: 0.95, offset: 0.5 },
      { transform: 'translate(' + endX + 'px,' + endY + 'px) scale(0.18) rotate(20deg)', opacity: 0 }
    ], {
      duration: 800,
      easing: 'cubic-bezier(0.45, 0.05, 0.55, 0.95)',
      fill: 'forwards'
    });
    anim.onfinish = function() {
      if (clone.parentNode) clone.parentNode.removeChild(clone);
    };
  } else {
    /* Fallback for very old browsers */
    clone.style.transition = 'transform 0.8s cubic-bezier(0.45,0.05,0.55,0.95), opacity 0.8s';
    void clone.offsetHeight;
    clone.style.transform = 'translate(' + endX + 'px,' + endY + 'px) scale(0.18) rotate(20deg)';
    clone.style.opacity = '0';
    setTimeout(function() {
      if (clone.parentNode) clone.parentNode.removeChild(clone);
    }, 850);
  }

  /* Cart icon bounce */
  setTimeout(function() {
    cartIcon.style.transition = 'transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)';
    cartIcon.style.transform = 'scale(1.3)';
    setTimeout(function() { cartIcon.style.transform = 'scale(1)'; }, 250);
  }, 700);
};
